import {
  DEACTIVATE_EVAL_SUCCESS,
  DEACTIVATE_EVAL_FAIL,
  CREATE_EVAL_FAIL,
  CREATE_EVAL_SUCCESS,
  LIST_EVAL_FAIL,
  LIST_EVAL_SUCCESS,
  ONE_EVAL_FAIL,
  ONE_EVAL_SUCCESS,
  ME_EVAL_SUCCESS,
  ME_EVAL_FAIL,
  SEARCH_EVAL_SUCCESS,
  SEARCH_EVAL_FAIL,
  LIST_EVAL_DESACTIVER_SUCCESS,
  LIST_EVAL_DESACTIVER_FAIL,
  EVALS_TO_COMPARE_SUCCESS,
  EVALS_TO_COMPARE_FAIL 
} from "../../actions/evaluation/type";

const initialState = {
  dataevals: {},
  dataeval: {},
  datameevals: [],
  comparedevals:[]
};
const evalReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LIST_EVAL_SUCCESS:
      return {
        ...state,
        dataevals: payload,
      };
    case LIST_EVAL_FAIL:
      return {
        ...state,
      };
    case ME_EVAL_SUCCESS:
      return {
        ...state,
        dataevals: payload,
      };
    case ME_EVAL_FAIL:
      return {
        ...state,
      };
    case ONE_EVAL_SUCCESS:
      return {
        ...state,
        dataeval: payload,
      };
    case ONE_EVAL_FAIL:
      return {
        ...state,
      };
    case CREATE_EVAL_SUCCESS:
      return {
        ...state,
        dataevals: payload,
      };
    case CREATE_EVAL_FAIL:
      return {
        ...state,
      };
    case SEARCH_EVAL_SUCCESS:
      return {
        ...state,
        dataevals: payload,
      };
    case SEARCH_EVAL_FAIL:
      return {
        ...state,
      };
      case LIST_EVAL_DESACTIVER_SUCCESS:
        return {
          ...state,
          dataevals: payload,
        };
        case LIST_EVAL_DESACTIVER_FAIL:
          return {
            ...state,
          };
    case DEACTIVATE_EVAL_SUCCESS:
      return {
        ...state,
        dataevals:  payload,
      };
    case DEACTIVATE_EVAL_FAIL:
      return {
        ...state,
        // idg: payload.id,
      };
      case EVALS_TO_COMPARE_SUCCESS:
      return {
        ...state,
        comparedevals: payload,
      };
    case EVALS_TO_COMPARE_FAIL:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default evalReducer;
